import React from 'react';
import { Link } from 'react-router-dom';
import { BeakerIcon } from '@heroicons/react/24/outline';
import { useBusinessTypeContext } from '../../contexts/BusinessTypeContext';

const GoatMilkRegister: React.FC = () => {
  const { businessType } = useBusinessTypeContext();

  if (businessType !== 'goat') {
    return (
      <div className="container-mobile py-8 text-center">
        <p className="text-gray-600">This page is only available for goat farming locations.</p>
        <Link to="/dashboard" className="text-blue-600 hover:text-blue-800">Go to Dashboard</Link>
      </div>
    );
  }

  return (
    <div className="container-mobile py-6 space-y-6">
      {/* Header */}
      <div className="text-center">
        <BeakerIcon className="h-16 w-16 text-yellow-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Milk Register</h1>
        <p className="text-lg text-gray-600">
          Record daily milk production and yield
        </p>
      </div>

      {/* Coming Soon Message */}
      <div className="card p-8 text-center">
        <div className="max-w-md mx-auto">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-yellow-100 mb-4">
              <BeakerIcon className="h-10 w-10 text-yellow-600" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Coming Soon</h2>
          <p className="text-gray-600 mb-6">
            We're working on building the Milk Register feature. This will allow you to:
          </p>
          <div className="space-y-2 text-left bg-gray-50 rounded-lg p-4">
            <p className="text-sm font-semibold text-gray-700 mb-2">Planned Features:</p>
            <ul className="space-y-1 text-sm text-gray-600">
              <li>• Record daily milk production per goat</li>
              <li>• Track milk yield trends over time</li>
              <li>• View milk production reports</li>
              <li>• Analyze production patterns</li>
              <li>• Export milk production data</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Navigation Links */}
      <div className="flex justify-center space-x-4">
        <Link
          to="/goat/logs"
          className="px-6 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors"
        >
          Back to Goat Logs
        </Link>
        <Link
          to="/goat/dashboard"
          className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default GoatMilkRegister;
